// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2hSCL","col":"styles_col__3TSY1"};